export const firebaseConfig = {
    apiKey: "AIzaSyAwa6NjJjdddmN8e9nHsWe1E0cVSGaDadY",
    authDomain: "wikyscan.firebaseapp.com",
    projectId: "wikyscan",
    storageBucket: "wikyscan.appspot.com",
    messagingSenderId: "1047107268143",
    appId: "1:1047107268143:web:3242c9bbd7830c723d20da",
    measurementId: "G-EVT28ZNZ5Y"
}